'use client';

import { CSSProperties, ComponentType, useEffect, useState } from 'react';

interface AnimatedNumberProps {
  animateToNumber: number;
  className?: string;
  fontStyle?: CSSProperties;
  includeComma?: boolean;
  locale?: string;
  transitions?: (index: number) => unknown;
}

function resolveAnimatedNumbersComponent(module: unknown): ComponentType<AnimatedNumberProps> {
  const candidate =
    (module as { default?: { default?: unknown } }).default?.default ??
    (module as { default?: unknown }).default ??
    module;

  return candidate as ComponentType<AnimatedNumberProps>;
}

export const AnimatedNumber = (props: AnimatedNumberProps) => {
  const [AnimatedNumbers, setAnimatedNumbers] = useState<ComponentType<AnimatedNumberProps> | null>(
    null,
  );

  useEffect(() => {
    let isMounted = true;

    import('react-animated-numbers').then(module => {
      if (!isMounted) return;
      setAnimatedNumbers(() => resolveAnimatedNumbersComponent(module));
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!AnimatedNumbers) {
    return null;
  }

  return <AnimatedNumbers {...props} />;
};
